var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegisterbutton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 49,
    viewBox: "0 0 154 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_469_7377)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145.664,
    height: 40.4188,
    fill: "#C49A6C"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_469_7377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.0625,
    y: 7.92523,
    width: 129.539,
    height: 23.7757,
    fill: "#E8CFA6"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9.6748,
    y: 9.51031,
    width: 2.68753,
    height: 4.75515,
    fill: "#C49A6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.6748,
    y: 25.3608,
    width: 2.68753,
    height: 4.75515,
    fill: "#C49A6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.301,
    y: 9.51031,
    width: 3.22503,
    height: 4.75515,
    fill: "#C49A6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.301,
    y: 25.3608,
    width: 3.22503,
    height: 4.75515,
    fill: "#C49A6C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.056 26H22.168V21.776H25.112C25.736 21.776 25.976 22.128 25.976 22.64V26H28.088V22.336C28.088 21.44 27.592 20.864 26.744 20.816V20.528C27.688 20.144 28.408 19.328 28.408 17.984V17.792C28.408 15.984 27.016 14.8 24.92 14.8H20.056V26ZM22.168 19.856V16.72H24.696C25.72 16.72 26.296 17.312 26.296 18.208V18.368C26.296 19.264 25.688 19.856 24.696 19.856H22.168ZM33.8454 26.224C36.0214 26.224 36.9654 24.992 37.4134 24.144L35.7654 23.28C35.4934 23.888 35.0294 24.464 33.9094 24.464C32.7894 24.464 31.9414 23.712 31.8934 22.624H37.6694V21.936C37.6694 19.504 36.1494 17.84 33.8134 17.84C31.4454 17.84 29.8454 19.44 29.8454 21.936V22.128C29.8454 24.624 31.4614 26.224 33.8454 26.224ZM31.9094 21.12C32.0534 20.208 32.7094 19.6 33.7974 19.6C34.8374 19.6 35.5254 20.208 35.6214 21.12H31.9094ZM39.0798 22.064C39.0798 24.56 40.7438 26.032 42.6958 26.032C44.1518 26.032 44.8078 25.424 45.1278 24.896H45.4158V26.96C45.4158 27.28 45.2558 27.44 44.9678 27.44H40.3598V29.2H45.6718C46.7278 29.2 47.4318 28.496 47.4318 27.408V18.064H45.4478V19.024H45.1598C44.8078 18.48 44.1358 17.84 42.6958 17.84C40.7278 17.84 39.0798 19.312 39.0798 21.808V22.064ZM43.2718 24.272C42.0398 24.272 41.0958 23.456 41.0958 22.016V21.856C41.0958 20.416 42.0238 19.6 43.2718 19.6C44.5198 19.6 45.4478 20.416 45.4478 21.856V22.016C45.4478 23.456 44.5038 24.272 43.2718 24.272ZM50.6749 17.136C51.4109 17.136 51.9709 16.624 51.9709 15.856C51.9709 15.088 51.4109 14.576 50.6749 14.576C49.9389 14.576 49.3789 15.088 49.3789 15.856C49.3789 16.624 49.9389 17.136 50.6749 17.136ZM49.6669 26H51.6829V18.064H49.6669V26ZM57.2129 26.224C59.2289 26.224 60.5409 25.28 60.5409 23.616C60.5409 21.952 59.1329 21.44 57.3409 21.12L56.8929 21.04C56.1569 20.912 55.7089 20.704 55.7089 20.192C55.7089 19.728 56.1249 19.44 56.8929 19.44C57.6609 19.44 58.2049 19.744 58.3809 20.56L60.2529 19.984C59.8849 18.704 58.6689 17.84 56.8929 17.84C55.0049 17.84 53.7569 18.72 53.7569 20.288C53.7569 21.856 55.1329 22.48 56.7969 22.784L57.2449 22.864C58.1889 23.04 58.5889 23.264 58.5889 23.76C58.5889 24.256 58.1409 24.624 57.2129 24.624C56.2849 24.624 55.5329 24.272 55.3249 23.152L53.4689 23.632C53.7409 25.296 55.1329 26.224 57.2129 26.224ZM65.1913 26H67.4313V24.336H65.8953C65.6073 24.336 65.4473 24.176 65.4473 23.856V19.728H67.6233V18.064H65.4473V15.6H63.4313V18.064H61.4473V19.728H63.4313V24.208C63.4313 25.296 64.1353 26 65.1913 26ZM72.7829 26.224C74.9589 26.224 75.9029 24.992 76.3509 24.144L74.7029 23.28C74.4309 23.888 73.9669 24.464 72.8469 24.464C71.7269 24.464 70.8789 23.712 70.8309 22.624H76.6069V21.936C76.6069 19.504 75.0869 17.84 72.7509 17.84C70.3829 17.84 68.7829 19.44 68.7829 21.936V22.128C68.7829 24.624 70.3989 26.224 72.7829 26.224ZM70.8469 21.12C70.9909 20.208 71.6469 19.6 72.7349 19.6C73.7749 19.6 74.4629 20.208 74.5589 21.12H70.8469ZM78.4013 26H80.4173V21.488C80.4173 20.368 81.1533 19.824 82.1773 19.824H83.1693V18.032H82.2093C81.4733 18.032 80.8973 18.32 80.6733 18.96H80.3853V18.064H78.4013V26ZM88.7435 26H90.8235V16.24H91.1115L93.3355 26H97.3515V14.8H95.2715V24.56H94.9835L92.7595 14.8H88.7435V26ZM103.302 26.224C105.67 26.224 107.462 24.72 107.462 22.16V21.904C107.462 19.344 105.67 17.84 103.302 17.84C100.934 17.84 99.1423 19.344 99.1423 21.904V22.16C99.1423 24.72 100.934 26.224 103.302 26.224ZM103.302 24.432C102.07 24.432 101.158 23.6 101.158 22.112V21.952C101.158 20.464 102.054 19.632 103.302 19.632C104.55 19.632 105.446 20.464 105.446 21.952V22.112C105.446 23.6 104.534 24.432 103.302 24.432ZM109.932 26H113.276L114.3 19.424H114.588L115.612 26H118.956L120.076 18.064H118.076L117.372 24.64H117.084L116.06 18.064H112.828L111.804 24.64H111.516L110.812 18.064H108.812L109.932 26ZM122.079 22.32H124.127V14.8H122.079V22.32ZM123.103 26.224C123.967 26.224 124.623 25.6 124.623 24.704C124.623 23.808 123.967 23.184 123.103 23.184C122.239 23.184 121.583 23.808 121.583 24.704C121.583 25.6 122.239 26.224 123.103 26.224Z",
    fill: "#5E3643"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_469_7377",
    x: 0,
    y: 0,
    width: 153.664,
    height: 48.4188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_469_7377"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_469_7377",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_469_7377",
    x: 8.0625,
    y: 7.92523,
    width: 137.539,
    height: 31.7758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_469_7377"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_469_7377",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterbutton);
export default __webpack_public_path__ + "static/media/registerbutton.e9b7d23d2ce08f7235abf4b334036f63.svg";
export { ForwardRef as ReactComponent };